import React, { useState, useEffect } from "react";
import { auth, db } from "../firebase";
import { doc, updateDoc, onSnapshot } from "firebase/firestore";
import { onAuthStateChanged } from "firebase/auth";
import { useNavigate } from "react-router-dom";

export default function Premium() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [userId, setUserId] = useState(null);
  const [status, setStatus] = useState("");
  const [isPremium, setIsPremium] = useState(false);

  useEffect(() => {
    let unsubscribeSnapshot;

    const unsubscribeAuth = onAuthStateChanged(auth, async (user) => {
      if (!user) {
        navigate("/");
      } else {
        setUserId(user.uid);
        const userRef = doc(db, "users", user.uid);

        unsubscribeSnapshot = onSnapshot(userRef, (snap) => {
          if (snap.exists()) {
            const data = snap.data();
            setStatus(data.paymentStatus || "");
            setIsPremium(data.isPremium === true && data.paymentStatus === "approved");
          }
          setLoading(false);
        });
      }
    });

    return () => {
      unsubscribeAuth();
      if (unsubscribeSnapshot) unsubscribeSnapshot();
    };
  }, [navigate]);

  async function handlePayment() {
    try {
      await updateDoc(doc(db, "users", userId), { paymentStatus: "pending" });
      alert("✅ Payment received! Waiting for admin approval");
    } catch (error) {
      console.error(error);
      alert("Payment failed");
    }
  }

  if (loading) return <p>Loading...</p>;

  return (
    <div style={{ padding: 20, fontFamily: "sans-serif" }}>
      <h2>Upgrade to Premium 🚀</h2>

      <div style={{ border: "1px solid #ccc", padding: 20, borderRadius: 15, marginBottom: 20 }}>
        <h3>Premium Plan</h3>
        <p>Access all premium services</p>
        <h2>₹99 / month</h2>
      </div>

      {status === "pending" && (
        <p style={{ color: "orange" }}>⏳ Waiting for admin approval...</p>
      )}

      {status === "approved" && isPremium && (
        <p style={{ color: "green" }}>🎉 Premium Activated!</p>
      )}

      {status === "rejected" && (
        <p style={{ color: "red" }}>❌ Request rejected. Please try again.</p>
      )}

      {!isPremium && status !== "pending" && (
        <button
          onClick={handlePayment}
          style={{
            padding: 12, background: "green", color: "#fff",
            border: "none", borderRadius: 10, fontSize: 16, cursor: "pointer"
          }}
        >
          Pay Now
        </button>
      )}

      <br /><br />
      <button
        onClick={() => navigate("/dashboard")}
        style={{ padding: 10, borderRadius: 8, cursor: "pointer" }}
      >
        ← Back
      </button>
    </div>
  );
}
